import VueRouter from 'vue-router'

let routes = [
    {
        name: 'Dashboard',
        path: '/admin',
        redirect: '/admin/',
        component: require('../views/accounts/default').default,
        children: [
            {
                name: 'Accounts',
                path: '',
                component: require('../views/accounts/index').default
            },
            {
                name: 'Add User',
                path: 'users/add',
                component: require('../views/users/add').default
            },
            {
                name: 'Account',
                path: 'company/:id',
                component: require('../views/company').default
            },
            {
                name: 'Rate',
                path: 'company/:company_id/rate/:id',
                component: require('../views/rate').default
            },
        ]
    },
    {
        name: 'Pending Pre-signups',
        path: '/admin/pre-sign-ups',
        component: require('../views/pre-signups').default
    },
    {
        name: 'Profile',
        path: '/admin/profile',
        component: require('../views/profile').default
    },
    {
        name: 'Billing',
        path: '/admin/billing',
        component: require('../views/billing').default
    },
    {
        name: 'Support Tools',
        path: '/admin/support-tools',
        component: require('../views/support-tools').default
    },
    {
        name: 'Login',
        path: '/admin/login',
        component: require('../views/login').default
    },
    {
        path: '*',
        component: require('../views/errors/404').default
    }
];

export default new VueRouter({
    mode: 'history',
    routes
});
